import React, { useState, useEffect, useRef } from "react";
import { format } from "date-fns";
import {
  concateAddress,
  convertToOriginalForm,
} from "../../../services/StringOperation";
import { getGoogleMapsUrl } from "../../../services/GlobalMapCallingAddressUrlFunctions";
import {
  openNewTabWithId,
  redirectUrl,
  redirectWindowUrl,
} from "../../../services/GlobalUrls";
import {
  errorToast,
  getDataOnRequest,
  submitDataOnRequest,
  successToast,
  updateDataOnRequest,
} from "../../../redux/actions/CommonActions";
import { connect, useDispatch } from "react-redux";
import { isAuthenticated } from "../../../redux/selectors/AuthSelectors";
import {
  addMinutes,
  getCurrentDateTime,
} from "../../../services/GlobalCurrentDateAndTime";
import Input from "../../FormElements/Input";
import Swal from "sweetalert2";
const MainSwipeInOrOutAssignments = ({
  curretAssinmentIndividualData,
  setShiftAttendanceDetails,
  setLoaderDone,
  setShowSwipeInModal,
  deviceInfo,
  ...props
}) => {
  const [showModalType, setModalType] = useState({});
  const dispatch = useDispatch();
  const [showAssignmentDetails, setShowAssignmentDetails] = useState(() => {
    const storedData = localStorage.getItem("curretAssinmentIndividualData");
    return storedData ? JSON.parse(storedData) : {};
  });
  const [lateAttendanceReason, setLateAttendanceReason] = useState("");
  const [showLateAttendanceReason, setShowLateAttendanceReason] =
    useState(false);

  useEffect(() => {
    localStorage.setItem(
      "curretAssinmentIndividualData",
      JSON.stringify(showAssignmentDetails)
    );
  }, [showAssignmentDetails]);

  // Determine the number of properties in showAssignmentDetails
  const numberOfProperties = Object.keys(showAssignmentDetails).length;

  const submitSwipeInorOut = (
    modalContent,
    callParam,
    callListTag,
    callDivCloumnTag
  ) => {
    const explodeAssignmentIds = modalContent.cnd_assignment_id?.split("_");
    // console.log("Check Explode Array :=> ", JSON.stringify(modalContent));
    const { currentDate, currentTime } = getCurrentDateTime(); // UK time
    const availabilityDate = modalContent.cnd_assignment_availability_date; // "YYYY-MM-DD"
    const startTime = modalContent.cnd_assignment_start_time; // "HH:mm"
    const endTime = modalContent.cnd_assignment_end_time; // "HH:mm"

    // Convert shift start to full UK datetime
    const shiftStart = new Date(`${availabilityDate}T${startTime}`);
    // Convert shift end to full UK datetime
    let shiftEnd = new Date(`${availabilityDate}T${endTime}`);

    // 🧠 Handle overnight case: if endTime is earlier than or equal to startTime, shiftEnd is next day
    if (shiftEnd <= shiftStart) {
      shiftEnd.setDate(shiftEnd.getDate() + 1);
    }

    // 🕒 Use current date + time in UK timezone to construct full datetime
    const formattedNowTime = new Date(`${currentDate}T${currentTime}`);

    // Determine whether to compare against shiftStart or shiftEnd
    const assignmentTime =
      modalContent.modalType === "swipe_in" ? shiftStart : shiftEnd;

    // ✅ Final condition
    if (
      ((formattedNowTime <= assignmentTime &&
        modalContent.modalType === "swipe_in") ||
        (formattedNowTime >= assignmentTime &&
          modalContent.modalType === "swipe_out") ||
        validateReasons(callListTag, "validate") === false) &&
      callParam === "submit"
    ) {
      let formDatails = {
        users_access_token: props.userAuth?.users_access_token,
        candidate_shift_attendance_assignment_id: explodeAssignmentIds[0]
          ? explodeAssignmentIds[0]
          : "",
        candidate_shift_attendance_connected_assignment_id:
          explodeAssignmentIds[1] ? explodeAssignmentIds[1] : "",
        candidate_shift_attendance_assignment_type:
          modalContent.cnd_assignment_work_shift_type_key,
        candidate_shift_attendance_candidate_id:
          modalContent.cnd_assignment_candidate_id,
        candidate_shift_attendance_client_type:
          modalContent.cnd_assignment_client_type,
        candidate_shift_attendance_client_id:
          modalContent.cnd_assignment_client_id,
        candidate_shift_attendance_client_branch_id:
          modalContent.cnd_assignment_client_branch_id,
        candidate_shift_attendance_weekdate_id:
          modalContent.cnd_assignment_weekdate_id,
        candidate_shift_attendance_assignment_date:
          modalContent.cnd_assignment_availability_date,
        candidate_shift_attendance_shift_start_time:
          modalContent.cnd_assignment_start_time,
        candidate_shift_attendance_shift_end_time:
          modalContent.cnd_assignment_end_time,
        candidate_shift_attendance_type: modalContent.modalType,
        candidate_shift_attendance_swipe_in_out_date: currentDate,
        candidate_shift_attendance_swipe_in_out_time: currentTime,
        candidate_shift_attendance_swipe_in_out_late_reason:
          lateAttendanceReason,
      };
      if (formDatails) {
        setLoaderDone(false);
        dispatch(
          submitDataOnRequest(
            JSON.stringify(formDatails),
            "SubmitCandidatesAssignmentsAttendance",
            "",
            [
              getDataOnRequest(
                props.userAuth.users_access_token,
                "GetCurrentAssignmentsForSwipeInOrOut",
                "SET_MY_CURRENT_ASSIGNMENTS"
              ),
            ]
          )
        )
          .then((response) => {
            if (response.status == "success") {
              setTimeout(() => {
                setLoaderDone(true);
              }, 1500);
              successToast(response.msg);
              setShiftAttendanceDetails(response.data);
              if (
                modalContent.cnd_assignment_client_type == "domiciliary_care" &&
                modalContent.modalType == "swipe_out"
              ) {
                setShowAssignmentDetails(modalContent);
                localStorage.setItem(
                  "curretAssinmentIndividualData",
                  JSON.stringify(modalContent ? modalContent : {})
                );
              } else {
                if (callDivCloumnTag) {
                  let callListTagDetails =
                    document.getElementById(callDivCloumnTag);

                  if (callListTagDetails) {
                    callListTagDetails.style.display = "none";
                  }

                  // Ensure function is correctly fetching updated elements
                  const updatedElements = getCallDivColumnElements();

                  if (updatedElements && updatedElements.arrayElements) {
                    if (updatedElements.arrayLength == 0) {
                      //setShowSwipeInModal(false);
                      //   redirectUrl(window.location.pathname);
                    }
                    setModalType({
                      elements: updatedElements.arrayElements,
                      length: updatedElements.arrayLength,
                    });
                    setShowAssignmentDetails({});
                  }
                }
              }
            } else {
              if (
                response.status == "error" &&
                (response.msg == "You Have Already Swipe In" ||
                  response.msg == "You Have Already Swipe Out")
              ) {
                dispatch(
                  getDataOnRequest(
                    props.userAuth.users_access_token,
                    "GetCurrentAssignmentsForSwipeInOrOut",
                    "SET_MY_CURRENT_ASSIGNMENTS"
                  )
                );
                setTimeout(() => {
                  setLoaderDone(true);
                }, 1500);
                if (callDivCloumnTag) {
                  let callListTagDetails =
                    document.getElementById(callDivCloumnTag);

                  if (callListTagDetails) {
                    callListTagDetails.style.display = "none";
                  }

                  // Ensure function is correctly fetching updated elements
                  const updatedElements = getCallDivColumnElements();

                  if (updatedElements && updatedElements.arrayElements) {
                    if (updatedElements.arrayLength == 0) {
                      //setShowSwipeInModal(false);
                      //   redirectUrl(window.location.pathname);
                    }
                    setModalType({
                      elements: updatedElements.arrayElements,
                      length: updatedElements.arrayLength,
                    });
                    setShowAssignmentDetails({});
                    setShiftAttendanceDetails(response.data);
                  }
                }
              }

              if (response.status == "warning") {
                Swal.fire({
                  title: "",
                  text: response.msg,
                  icon: "info",
                  showCancelButton: false,
                  showDenyButton: false,
                  confirmButtonText: "Ok",
                  cancelButtonText: "Ignore",
                  denyButtonText: "Remind Me Later",
                }).then((result) => {
                  if (result.isConfirmed) {
                    // window.location.href = "";
                    dispatch(
                      getDataOnRequest(
                        props.userAuth.users_access_token,
                        "GetCurrentAssignmentsForSwipeInOrOut",
                        "SET_MY_CURRENT_ASSIGNMENTS"
                      )
                    );
                    setTimeout(() => {
                      setLoaderDone(true);
                    }, 1500);
                    if (callDivCloumnTag) {
                      let callListTagDetails =
                        document.getElementById(callDivCloumnTag);

                      if (callListTagDetails) {
                        callListTagDetails.style.display = "none";
                      }

                      // Ensure function is correctly fetching updated elements
                      const updatedElements = getCallDivColumnElements();

                      if (updatedElements && updatedElements.arrayElements) {
                        if (updatedElements.arrayLength == 0) {
                          //setShowSwipeInModal(false);
                          //   redirectUrl(window.location.pathname);
                        }
                        setModalType({
                          elements: updatedElements.arrayElements,
                          length: updatedElements.arrayLength,
                        });
                        setShowAssignmentDetails({});
                        setShiftAttendanceDetails(response.data);
                      }
                    }
                  } /*else if (result.isDenied) {
                  //console.log("User clicked 'Remind Me Later'");
                  // Execute action for reminder
                } else if (result.isDismissed) {
                  //console.log("User clicked 'Ignore' or closed the modal");
                  // Handle the ignore case
                }*/
                });
              } else {
                errorToast(response.msg);
              }
            }
          })
          .catch((error) => {
            errorToast(error.message);
          });

        // validateReasons(callListTag, "hide")
      }
    } else {
      validateReasons(callListTag, "show");
    }
  };

  const validateReasons = (callListTag, checkParam) => {
    let applyError = false;
    if (callListTag) {
      let callListTagElement = document.getElementById(callListTag);
      if (callListTagElement) {
        if (checkParam == "show" || checkParam == "validate") {
          if (checkParam == "show") {
            callListTagElement.style.display = "block";
          } else {
            callListTagElement.style.display = "block";
            const multiFormsDiv = document.getElementById(callListTag);

            // Get all elements inside the div
            const elementsInsideDiv = multiFormsDiv.querySelectorAll("[id]");

            elementsInsideDiv.forEach((element) => {
              const elementType = element.type;
              switch (elementType) {
                case "text":
                  // Your validation logic for text fields
                  let textTypeId = document.getElementById(element.id);
                  let textTypeIdMsg = document.getElementById(
                    element.id + "_msg"
                  );
                  if (textTypeId.value.trim() === "") {
                    textTypeId.classList.add("border-danger");
                    textTypeIdMsg.innerText = "Please enter the reason!";
                    if (applyError == false) {
                      textTypeId.focus();
                    }
                    applyError = true;
                    // invalidFields.push(element.id);
                  } else {
                    textTypeId.classList.remove("border-danger");
                    textTypeIdMsg.innerText = "";
                    // invalidFields.pop(element.id);
                  }
                  break;

                default:
                  break;
              }
            });
          }
        } else {
          callListTagElement.style.display = "none";
        }
      }
    }

    return applyError;
  };

  const callMapUrl = (mapAddress) => {
    const getMapUrl = getGoogleMapsUrl(mapAddress);
    if (getMapUrl) {
      redirectWindowUrl(getMapUrl);
    }
  };

  function getCallDivColumnElements() {
    try {
      // Get the main container
      const multiFormsDiv = document.getElementById("call_row_tag");

      // Ensure the element exists to avoid errors
      if (!multiFormsDiv) {
        console.warn("Element with ID 'call_row_tag' not found.");
        return { arrayElements: [], arrayLength: 0 };
      }

      // Get all child elements whose ID starts with "call_div_column_"
      const elementsInsideDiv = multiFormsDiv.querySelectorAll(
        '[id^="call_div_column_"]'
      );

      // Ensure elements are found
      if (!elementsInsideDiv || elementsInsideDiv.length === 0) {
        console.warn(
          "No elements found with ID prefix 'call_div_column_' inside 'call_row_tag'."
        );
        return { arrayElements: [], arrayLength: 0 };
      }

      // Extract IDs from the selected elements only if they are visible (display !== "none")
      const columnCountArray = Array.from(elementsInsideDiv)
        .filter((el) => window.getComputedStyle(el).display !== "none") // ✅ Check if element is visible
        .map((el) => el.id);

      //console.log("Visible Call Array Elements:", columnCountArray);

      return {
        arrayElements: columnCountArray, // Array of matched element IDs
        arrayLength: columnCountArray.length, // Count of matched elements
      };
    } catch (error) {
      console.error("Error in getCallDivColumnElements:", error);
      return { arrayElements: [], arrayLength: 0 };
    }
  }

  // Function to clear the assignment details
  const submitDailyLogs = (
    dailyLogsOp,
    modalContent,
    callParam,
    callListTag,
    callDivCloumnTag
  ) => {
    // console.log("Demo Test ", JSON.stringify(curretAssinmentIndividualData));
    let formDatails = {
      users_access_token: props.userAuth?.users_access_token,
      cnd_daily_logs_service_user_id: modalContent.cnd_assignment_client_id,
      cnd_daily_logs_date: modalContent.cnd_assignment_availability_date,
      cnd_daily_logs_start_time: modalContent.cnd_assignment_start_time,
      cnd_daily_logs_end_time: modalContent.cnd_assignment_end_time,
      cnd_assignment_id: modalContent.cnd_assignment_id,
    };
    if (formDatails) {
      setLoaderDone(false);
      dispatch(
        submitDataOnRequest(JSON.stringify(formDatails), "SaveDailyLog", "", [
          getDataOnRequest(
            props.userAuth.users_access_token,
            "GetDailyLogs",
            "SET_DAILY_LOGS"
          ),
          getDataOnRequest(
            props.userAuth.users_access_token,
            "GetCurrentAssignmentsForSwipeInOrOut",
            "SET_MY_CURRENT_ASSIGNMENTS"
          ),
        ])
      )
        .then((response) => {
          let checkExecution = false;
          if (response.status == "success") {
            setTimeout(() => {
              setLoaderDone(true);
            }, 1500);
            if (dailyLogsOp == "do_it_later") {
              Swal.fire({
                title: "Skipped Daily Logs",
                text: "You have skipped your daily logs. To complete them, please go to the pending daily logs list.",
                icon: "info",
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: "Ok",
                cancelButtonText: "Ignore",
                denyButtonText: "Remind Me Later",
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  checkExecution = true;
                  if (
                    Array.isArray(curretAssinmentIndividualData) &&
                    curretAssinmentIndividualData.length <= 1
                  ) {
                    window.location.reload();
                  }
                }

                /*else if (result.isDenied) {
                  //console.log("User clicked 'Remind Me Later'");
                  // Execute action for reminder
                } else if (result.isDismissed) {
                  //console.log("User clicked 'Ignore' or closed the modal");
                  // Handle the ignore case
                }*/
              });
            } else if (dailyLogsOp == "fill_now" && response?.lastInsertId) {
              checkExecution = openNewTabWithId(
                response?.lastInsertId,
                "/update-daily-logs"
              );
              if (
                Array.isArray(curretAssinmentIndividualData) &&
                curretAssinmentIndividualData.length <= 1
              ) {
                window.location.reload();
              }
            }
            // successToast(response.msg);
            if (callDivCloumnTag) {
              let callListTagDetails =
                document.getElementById(callDivCloumnTag);

              if (callListTagDetails) {
                callListTagDetails.style.display = "none";
              }

              setShowAssignmentDetails({});
              localStorage.removeItem("curretAssinmentIndividualData");
              // Ensure function is correctly fetching updated elements
              const updatedElements = getCallDivColumnElements();

              if (dailyLogsOp == "fill_now") {
                const timer = setTimeout(() => {
                  if (updatedElements && updatedElements.arrayElements) {
                    if (updatedElements.arrayLength == 0) {
                      //setShowSwipeInModal(false);
                      // if (checkExecution == true) {
                      //   redirectUrl(window.location.pathname);
                      // }
                    }
                    setModalType({
                      elements: updatedElements.arrayElements,
                      length: updatedElements.arrayLength,
                    });
                    setShowAssignmentDetails({});
                  }
                }, 1500);
                // Cleanup function to clear the timer
                return () => clearTimeout(timer);
              } else {
                if (updatedElements && updatedElements.arrayElements) {
                  if (updatedElements.arrayLength == 0) {
                    //setShowSwipeInModal(false);
                    if (checkExecution == true) {
                      //   redirectUrl(window.location.pathname);
                    }
                  }
                  setModalType({
                    elements: updatedElements.arrayElements,
                    length: updatedElements.arrayLength,
                  });
                  setShowAssignmentDetails({});
                }
              }
            }
          } else {
            dispatch(
              getDataOnRequest(
                props.userAuth.users_access_token,
                "GetCurrentAssignmentsForSwipeInOrOut",
                "SET_MY_CURRENT_ASSIGNMENTS"
              )
            );
            errorToast(response.msg);
            setTimeout(() => {
              setLoaderDone(true);
            }, 1500);
          }
        })
        .catch((error) => {
          errorToast(error.message);
        });

      // validateReasons(callListTag, "hide")
    }
  };

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        <div className="container">
          {/* <pre>{JSON.stringify(curretAssinmentIndividualData, null, 2)}</pre> */}
          {/* <pre>{JSON.stringify(showAssignmentDetails, null, 2)}</pre> */}
          {/* {JSON.stringify(showModalType)} */}
          <div className="row" id="call_row_tag">
            {curretAssinmentIndividualData.map((itemValue, i) => {
              const assignmentId = itemValue.cnd_assignment_id;
              if (
                itemValue.candidate_shift_attendance_type !=
                  itemValue.modalType ||
                showAssignmentDetails
              ) {
                return (
                  <>
                    <div
                      className={
                        "col-sm-" +
                        (curretAssinmentIndividualData.length > 1 ? "12" : "12")
                      }
                      id={`call_div_column_${assignmentId}`}
                      key={assignmentId}
                    >
                      <ul
                        className="nav navbar-nav border border-grey p-4 mb-2"
                        style={{ borderRadius: "20px" }}
                      >
                        <li className="text-dark">
                          <i className="fa fa-user-circle mr-1 text-primary"></i>{" "}
                          {itemValue.clt_company_name
                            ? itemValue.clt_company_name.length <= 15
                              ? itemValue.clt_company_name
                              : itemValue.clt_company_name
                            : ""}
                        </li>
                        {itemValue.cnd_assignment_client_branch_id &&
                          itemValue.cnd_assignment_client_branch_id ==
                            itemValue.clt_branch_id && (
                            <li className="text-dark">
                              <i className="fa fa-sitemap mr-1 text-primary"></i>{" "}
                              {itemValue.cnd_assignment_client_branch_id &&
                                itemValue.cnd_assignment_client_branch_id ==
                                  itemValue.clt_branch_id && (
                                  <>
                                    {itemValue.clt_branch_location
                                      ? String(
                                          itemValue.clt_branch_name +
                                            " - ( " +
                                            itemValue.clt_branch_location +
                                            " )"
                                        ).length <= 15
                                        ? itemValue.clt_branch_name +
                                          " - ( " +
                                          itemValue.clt_branch_location +
                                          " )"
                                        : String(
                                            itemValue.clt_branch_name +
                                              " - ( " +
                                              itemValue.clt_branch_location +
                                              " )"
                                          )
                                      : itemValue.clt_branch_name &&
                                          itemValue.clt_branch_name.length <= 15
                                        ? itemValue.clt_branch_name
                                        : itemValue.clt_branch_name
                                          ? itemValue.clt_branch_name
                                          : ""}
                                  </>
                                )}
                              {!itemValue.cnd_assignment_client_branch_id && (
                                <>
                                  {itemValue.clt_service_town
                                    ? String(
                                        itemValue.clt_company_name +
                                          " - ( " +
                                          itemValue.clt_service_town +
                                          " )"
                                      ).length <= 15
                                      ? itemValue.clt_company_name +
                                        " - ( " +
                                        itemValue.clt_service_town +
                                        " )"
                                      : String(
                                          itemValue.clt_company_name +
                                            " - ( " +
                                            itemValue.clt_service_town +
                                            " )"
                                        )
                                    : itemValue.clt_company_name &&
                                        itemValue.clt_company_name.length <= 15
                                      ? itemValue.clt_company_name
                                      : itemValue.clt_company_name
                                        ? itemValue.clt_company_name
                                        : ""}
                                </>
                              )}
                            </li>
                          )}
                        <li className="text-dark">
                          <i className="fa fa-calendar-o mr-1 text-primary"></i>{" "}
                          {format(
                            new Date(
                              itemValue.cnd_assignment_availability_date
                            ),
                            "dd-MM-yyyy"
                          ) +
                            " (" +
                            itemValue.cnd_availability_week_day
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                              )
                              .join(" ") +
                            ")"}
                        </li>
                        <li className="text-dark">
                          <i className="fa fa-clock-o mr-1 text-primary"></i>{" "}
                          {itemValue.cnd_assignment_start_time +
                            " - " +
                            itemValue.cnd_assignment_end_time}
                          {itemValue.cnd_assignment_work_shift_type == "regular"
                            ? " - (Regular)"
                            : itemValue.cnd_assignment_work_shift_type
                              ? " - " + itemValue.cnd_assignment_work_shift_type
                              : ""}
                        </li>

                        <li className="text-dark">
                          <i className="fa fa-suitcase mr-1 text-primary"></i>{" "}
                          {itemValue.cnd_assignment_job_roles
                            ? String(
                                convertToOriginalForm(
                                  itemValue.cnd_assignment_job_roles
                                )
                              ).length <= 15
                              ? convertToOriginalForm(
                                  itemValue.cnd_assignment_job_roles
                                )
                              : convertToOriginalForm(
                                  itemValue.cnd_assignment_job_roles
                                )
                            : ""}
                          {itemValue.pay_and_charge_pay_rate &&
                            itemValue.pay_and_charge_pay_rate != "-" &&
                            deviceInfo != "Mobile" && (
                              <>
                                <b className="ml-1 mr-1 text-lg">|</b>
                                <i className="fa fa-money mr-1 text-primary"></i>{" "}
                                {itemValue.pay_and_charge_pay_rate
                                  ? String(
                                      convertToOriginalForm(
                                        itemValue.pay_and_charge_pay_rate
                                      )
                                    ).length <= 15
                                    ? convertToOriginalForm(
                                        itemValue.pay_and_charge_pay_rate
                                      )
                                    : convertToOriginalForm(
                                        itemValue.pay_and_charge_pay_rate
                                      )
                                  : ""}
                              </>
                            )}
                        </li>
                        {itemValue.pay_and_charge_pay_rate &&
                          itemValue.pay_and_charge_pay_rate != "-" &&
                          deviceInfo == "Mobile" && (
                            <li className="text-dark">
                              <i className="fa fa-money mr-1 text-primary"></i>{" "}
                              {itemValue.pay_and_charge_pay_rate
                                ? String(
                                    convertToOriginalForm(
                                      itemValue.pay_and_charge_pay_rate
                                    )
                                  ).length <= 15
                                  ? convertToOriginalForm(
                                      itemValue.pay_and_charge_pay_rate
                                    )
                                  : convertToOriginalForm(
                                      itemValue.pay_and_charge_pay_rate
                                    )
                                : ""}
                            </li>
                          )}

                        <li className="text-dark">
                          <i className="fa fa-medkit mr-1 text-primary"></i>{" "}
                          {itemValue.cnd_assignment_health_and__safety_implications
                            ? String(
                                itemValue.cnd_assignment_health_and__safety_implications
                              ).length <= 15
                              ? itemValue.cnd_assignment_health_and__safety_implications
                              : itemValue.cnd_assignment_health_and__safety_implications
                            : ""}
                        </li>

                        {concateAddress(
                          itemValue.clt_branch_address1,
                          itemValue.clt_branch_address2,
                          itemValue.clt_branch_town,
                          itemValue.clt_branch_region,
                          itemValue.clt_branch_postal
                        ) && (
                          <>
                            <li
                              className="text-primary"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                callMapUrl(
                                  concateAddress(
                                    itemValue.clt_branch_address1,
                                    itemValue.clt_branch_address2,
                                    itemValue.clt_branch_town,
                                    itemValue.clt_branch_region,
                                    itemValue.clt_branch_postal
                                  )
                                )
                              }
                            >
                              <i className="fa fa-map mr-1 text-primary"></i>{" "}
                              {concateAddress(
                                itemValue.clt_branch_address1,
                                itemValue.clt_branch_address2,
                                itemValue.clt_branch_town,
                                itemValue.clt_branch_region,
                                itemValue.clt_branch_postal
                              ) &&
                              String(
                                concateAddress(
                                  itemValue.clt_branch_address1,
                                  itemValue.clt_branch_address2,
                                  itemValue.clt_branch_town,
                                  itemValue.clt_branch_region,
                                  itemValue.clt_branch_postal
                                )
                              ).length <= 20
                                ? concateAddress(
                                    itemValue.clt_branch_address1,
                                    itemValue.clt_branch_address2,
                                    itemValue.clt_branch_town,
                                    itemValue.clt_branch_region,
                                    itemValue.clt_branch_postal
                                  )
                                : concateAddress(
                                    itemValue.clt_branch_address1,
                                    itemValue.clt_branch_address2,
                                    itemValue.clt_branch_town,
                                    itemValue.clt_branch_region,
                                    itemValue.clt_branch_postal
                                  )}
                            </li>
                          </>
                        )}

                        {showAssignmentDetails?.cnd_assignment_id !=
                          assignmentId && (
                          <li
                            className="mt-2 mb-0"
                            id={`call_list_tag_of_reasons_${assignmentId}`}
                            style={{ display: "none" }}
                          >
                            <div style={{ marginLeft: "-1rem" }}>
                              <Input
                                type="text"
                                req={false}
                                placeholder={`${
                                  itemValue.swipe_in_details
                                    ? "Early Swipe Out"
                                    : "Late Swipe In"
                                } Reason`}
                                name="candidate_shift_attendance_swipe_in_out_late_reason"
                                id={`candidate_shift_attendance_swipe_in_out_late_reason_${assignmentId}`}
                                changeHandler={(e) => {
                                  validateReasons(
                                    "call_list_tag_of_reasons_" + assignmentId,
                                    "validate"
                                  );
                                  setLateAttendanceReason(e.target.value);
                                }}
                                errorMsg={true}
                                lg={6}
                              />
                            </div>
                          </li>
                        )}

                        <li className="text-dark mt-2">
                          {showAssignmentDetails?.cnd_assignment_id ==
                          assignmentId ? (
                            <>
                              <div
                                className="row border border-grey p-3 mt-4 "
                                style={{ borderRadius: "10px" }}
                              >
                                <div className="col-sm-6">
                                  <span className="mb-1">
                                    <h5>Complete Daily Log?</h5>
                                  </span>
                                </div>

                                <div className="col-sm-6">
                                  <a
                                    className="text-white btn btn-sm btn-danger float-right"
                                    onClick={() =>
                                      submitDailyLogs(
                                        "do_it_later",
                                        itemValue,
                                        "submit",
                                        "call_list_tag_of_reasons_" +
                                          assignmentId,
                                        "call_div_column_" + assignmentId
                                      )
                                    }
                                  >
                                    I'll do it later
                                  </a>
                                  <a
                                    className="text-white btn btn-sm btn-success float-right mr-2"
                                    onClick={() =>
                                      submitDailyLogs(
                                        "fill_now",
                                        itemValue,
                                        "submit",
                                        "call_list_tag_of_reasons_" +
                                          assignmentId,
                                        "call_div_column_" + assignmentId
                                      )
                                    }
                                  >
                                    Now
                                  </a>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              {itemValue.show_button ? (
                                <a
                                  className={
                                    "text-white float-right btn btn-" +
                                    (itemValue.swipe_in_details
                                      ? "danger"
                                      : "primary")
                                  }
                                  onClick={() => {
                                    let updatedItem = { ...itemValue };

                                    if (!itemValue.swipe_in_details) {
                                      updatedItem.modalType = "swipe_in";
                                    } else if (!itemValue.swipe_out_details) {
                                      updatedItem.modalType = "swipe_out";
                                    }

                                    submitSwipeInorOut(
                                      updatedItem,
                                      "submit",
                                      "call_list_tag_of_reasons_" +
                                        assignmentId,
                                      "call_div_column_" + assignmentId
                                    );
                                  }}
                                >
                                  {itemValue.swipe_in_details
                                    ? "Swipe Out"
                                    : "Swipe In"}
                                </a>
                              ) : (
                                <a
                                  className="text-white float-right btn btn-warning"
                                  onClick={() => {
                                    Swal.fire({
                                      title: "Previous Shift Not Completed",
                                      text: "Please complete the swipe in/out for the previous shift before proceeding.",
                                      icon: "info",
                                      showCancelButton: false,
                                      showDenyButton: false,
                                      confirmButtonText: "Ok",
                                    });
                                  }}
                                >
                                  Waiting
                                </a>
                              )}
                            </>
                          )}
                        </li>
                      </ul>
                    </div>
                  </>
                );
              }
            })}
          </div>

          {/* <pre>{JSON.stringify(props.myCurrentRunningAssignments, null, 2)}</pre> */}
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    userAuth: state.auth.authUserData,
    myCurrentRunningAssignments:
      state.myCurrentRunningAssignments.myCurrentRunningAssignments,
  };
};

export default connect(mapStateToProps)(MainSwipeInOrOutAssignments);
